<template>
  <div class="promote-home">
    <div class="banner">
      <img src="/static/image/promote/home/ActiveImg19956066554176092.avif" class="banner-bg" />
    </div>

    <div class="agent-card">
      <div class="card-left">
        <div class="icon-wrapper">
          <img src="/static/image/promote/home/style_4_img_tpdl.avif" class="level-icon" />
        </div>
        <div class="account-box">
          <div class="account-row">
            <span class="account-label">代理账号</span>
          </div>
          <div class="account-row">
            <span class="account-value">{{ userInfo.username }}</span>
            <span class="help-btn">!</span>
          </div>
        </div>
      </div>
      <div class="card-right">
        <div class="info-row">
          <span class="row-label-title">代理模式：<span class="row-label-content">全民代理</span></span>
        </div>
        <div class="info-row">
          <span class="row-label-title">稽核倍数：<span class="row-label-content">0.00</span></span>
        </div>
        <div class="info-row">
          <span class="row-label-title">结算日期：<span class="row-label-content">{{ settleDate }}</span></span>
        </div>
        <div class="info-row">
            <span class="row-label-title">我的邀请码：
                <span class="row-label-content">{{ userInfo.id }}</span>
                <svg class="copy-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" @click="copyCode">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
            </span>
        </div>
      </div>
    </div>

    <div class="qr-section">
      <div class="qr-left">
        <div class="qr-placeholder">
          <img :src="qrCodeUrl" class="qr-img" v-if="qrCodeUrl" />
          <van-icon name="qr" size="60" color="#DFB372" v-else />
        </div>
        <div class="qr-tip">保存邀请码</div>
      </div>
      <div class="qr-right">
        <div class="share-link">
          <select class="link-select" v-model="selectedDomain" @change="updateShareLink">
            <option v-for="domain in domainList" :key="domain" :value="domain">{{ domain }}/#/?pid={{ userInfo.id }}</option>
          </select>
          <svg class="link-copy" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" @click="copyLink">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
        </div>
        <div class="share-buttons">
          <div class="share-item" @click="handleShare()">
            <div class="share-icon-share">
              <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="#DFB372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="18" cy="5" r="3"></circle>
                <circle cx="6" cy="12" r="3"></circle>
                <circle cx="18" cy="19" r="3"></circle>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
              </svg>
            </div>
            <span class="share-text">分享</span>
          </div>
          <div class="share-item" @click="shareToPlatform('wechat')">
            <img src="/static/image/promote/home/img_wx.png" class="share-icon-img" />
            <span class="share-text">Wechat</span>
          </div>
          <div class="share-item" @click="shareToPlatform('qq')">
            <img src="/static/image/promote/home/img_qq.png" class="share-icon-img" />
            <span class="share-text">QQ</span>
          </div>
          <div class="share-item" @click="shareToPlatform('moments')">
            <img src="/static/image/promote/home/img_pyq.png" class="share-icon-img" />
            <span class="share-text">WeChat</span>
            <span class="share-text" style="margin-top:0;">Moments</span>
          </div>
          <div class="share-item" @click="shareToPlatform('facebook')">
            <img src="/static/image/promote/home/img_facebook.png" class="share-icon-img" />
            <span class="share-text">Facebook</span>
          </div>
          <div class="share-item" @click="shareToPlatform('telegram')">
            <img src="/static/image/promote/home/img_tg.png" class="share-icon-img" />
            <span class="share-text">Telegram</span>
          </div>
        </div>
      </div>
    </div>

    <div class="stats-row">
      <div class="stat-left">
        <span class="stat-label">累计获得</span>
        <span class="stat-num gold">{{ userInfo.fanshui || '0.00' }}</span>
      </div>
      <div class="stat-right">
        <span class="stat-label">累计邀请人数</span>
        <span class="stat-num gold">0</span>
      </div>
    </div>

    <div class="data-card">
      <div class="card-header">
        <div class="card-title-row">
          <span class="title">我的佣金</span>
          <span class="subtitle">(距离下次结算 0天19:01:39)</span>
        </div>
        <div class="card-action">
          <span class="receive-btn">领取</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
      </div>
      <div class="card-body">
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">昨日直属业绩</span>
            <span class="data-value">0.00</span>
          </div>
          <div class="data-item">
            <span class="data-label">累计佣金</span>
            <span class="data-value">0.00</span>
          </div>
        </div>
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">已领取</span>
            <span class="data-value">0.00</span>
          </div>
          <div class="data-item">
            <span class="data-label">待领取</span>
            <span class="data-value gold">0.00</span>
          </div>
        </div>
      </div>
    </div>

    <div class="data-card">
      <div class="card-header">
        <div class="card-title-row inline">
          <span class="activity-tag">代理天花板</span>
          <span class="activity-desc">邀请好友即领100 奖励不设上限</span>
        </div>
        <div class="card-action">
          <span class="receive-btn">领取</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
      </div>
      <div class="card-body">
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">邀请有效人数</span>
            <span class="data-value">0</span>
          </div>
          <div class="data-item">
            <span class="data-label">奖励</span>
            <span class="data-value">0.00</span>
          </div>
        </div>
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">已领取</span>
            <span class="data-value">0.00</span>
          </div>
          <div class="data-item">
            <span class="data-label">待领取</span>
            <span class="data-value gold">0.00</span>
          </div>
        </div>
      </div>
    </div>

    <div class="data-card">
      <div class="card-header">
        <div class="card-title-row">
          <span class="title">代理推广</span>
          <span class="subtitle">日日返金 佣金加赠</span>
        </div>
        <div class="card-action">
          <span class="receive-btn">领取</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
      </div>
      <div class="card-body">
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">代理返佣</span>
            <span class="data-value">0.00</span>
          </div>
          <div class="data-item">
            <span class="data-label">奖励</span>
            <span class="data-value">0.00</span>
          </div>
        </div>
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">已领取</span>
            <span class="data-value">0.00</span>
          </div>
          <div class="data-item">
            <span class="data-label">待领取</span>
            <span class="data-value gold">0.00</span>
          </div>
        </div>
      </div>
    </div>

    <div class="data-card" style="margin-bottom:2rem;">
      <div class="card-header">
        <div class="card-title-row">
          <span class="title">代理推荐</span>
          <span class="subtitle">月月返利 充值加赠</span>
        </div>
        <div class="card-action">
          <span class="receive-btn">领取</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
      </div>
      <div class="card-body">
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">直属会员累计充值</span>
            <span class="data-value">0.00</span>
          </div>
          <div class="data-item">
            <span class="data-label">奖励</span>
            <span class="data-value">0.00</span>
          </div>
        </div>
        <div class="data-row">
          <div class="data-item">
            <span class="data-label">已领取</span>
            <span class="data-value">0.00</span>
          </div>
          <div class="data-item">
            <span class="data-label">待领取</span>
            <span class="data-value gold">0.00</span>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-space" ></div>
  </div>
</template>

<script>
export default {
  name: 'promoteHome',
  data() {
    return {
      userInfo: {},
      shareLink: '',
      qrCodeUrl: '',
      sharing: false,
      settleDate: '',
      domainList: [],
      selectedDomain: '',
    };
  },
  created() {
    this.getSettleDate();
    this.getUserInfo();
    this.initDomainList();
  },
  methods: {
    initDomainList() {
      let registerDomain = this.$store.state.appInfo.register_domain || '';
      if (registerDomain) {
        this.domainList = registerDomain.split(',').map(d => d.trim()).filter(d => d);
        if (this.domainList.length > 0) {
          this.selectedDomain = this.domainList[0];
          this.updateShareLink();
        }
      }
    },
    updateShareLink() {
      if (this.selectedDomain && this.userInfo.id) {
        let domain = this.selectedDomain;
        if (!domain.startsWith('http')) {
          domain = 'http://' + domain;
        }
        this.shareLink = domain + '/#/?pid=' + this.userInfo.id;
        this.qrCodeUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + encodeURIComponent(this.shareLink);
      }
    },
    getSettleDate() {
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      let y = tomorrow.getFullYear();
      let m = String(tomorrow.getMonth() + 1).padStart(2, '0');
      let d = String(tomorrow.getDate()).padStart(2, '0');
      this.settleDate = `${y}/${m}/${d}`;
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          that.userInfo = res.data;
          that.updateShareLink();
        }
      });
    },
    copyCode() {
      this.copyToClipboard(this.userInfo.id, '邀请码复制成功');
    },
    copyLink() {
      this.copyToClipboard(this.shareLink, '链接复制成功');
    },
    copyToClipboard(text, msg) {
      const done = () => this.$notify({ type: 'success', message: msg });
      const fail = () => this.$notify({ type: 'danger', message: '复制失败，请长按手动复制' });
      // 优先 execCommand（APP WebView 兼容性最好，clipboard API 在非 https 环境常被拒）
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      ta.setSelectionRange(0, String(text).length); // iOS WebView 必须
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(ta);
      if (ok) {
        done();
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(fail);
      } else {
        fail();
      }
    },
    handleShare() {
      navigator.share({
        title: '邀请注册',
        text: '邀请您注册，一起赚钱！',
        url: this.shareLink,
      });
    },
    shareToPlatform(type) {
      const shareUrl = encodeURIComponent(this.shareLink);
      const shareText = encodeURIComponent('邀请您注册，一起赚钱！');
      
      switch (type) {
        case 'wechat':
          const wechatUrl = `weixin://dl/business/?ticket=${encodeURIComponent(this.shareLink)}`;
          window.open(wechatUrl);
          break;
        case 'qq':
          const qqUrl = `mqq://shareui/openshare?url=${shareUrl}&title=${shareText}`;
          window.open(qqUrl);
          break;
        case 'moments':
          const momentsUrl = `weixin://dl/moments?url=${shareUrl}`;
          window.open(momentsUrl);
          break;
        case 'facebook':
          const fbUrl = `fb://share?href=${shareUrl}`;
          window.open(fbUrl);
          break;
        case 'telegram':
          const tgUrl = `tg://msg_url?url=${shareUrl}&text=${shareText}`;
          window.open(tgUrl);
          break;
      }
    },
    handleReceive() {
      this.$root.showTost(1, '领取成功');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../static/css/common.css';

.promote-home {
  min-height: 100vh;
  background: #292A2C;
  padding: 0.2rem;
  box-sizing: border-box;
}

.banner {
  position: relative;
  height: 4.2rem;
  border-radius: 0.16rem;
  overflow: hidden;
  margin-bottom: 0.24rem;

  .banner-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  .banner-content {
    position: relative;
    z-index: 2;
    padding: 0.2rem 0.3rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .banner-tag {
    position: absolute;
    top: 0;
    left: 0;
    background: #DFB372;
    color: #292A2C;
    font-size: 0.18rem;
    padding: 0.03rem 0.15rem;
    border-radius: 0 0 0.1rem 0;
    font-weight: bold;
  }

  .banner-title {
    font-size: 0.4rem;
    font-weight: bold;
    color: #fff;
    margin-bottom: 0.1rem;
    text-shadow: 0 2px 4px rgba(0,0,0,0.5);
  }

  .banner-subtitle {
    font-size: 0.24rem;
    color: #fff;
    text-shadow: 0 2px 4px rgba(0,0,0,0.5);

    .highlight {
      font-weight: bold;

      &.gold {
        color: #DFB372;
      }
    }
  }
}

.agent-card {
  background: linear-gradient(90deg, #f3ca8e 0%, #dfb372 100%);
  border-radius: 0.16rem;
  padding: 0 0.2rem;
  box-sizing: border-box;
  margin-bottom: 0.24rem;
  display: flex;
  min-height: 2.8rem;

  .card-left {
    width: 38%;
    display: flex;
    flex-direction: column;
    padding-right: 0.2rem;
    // border-right: 1px solid rgba(0,0,0,0.15);

    .icon-wrapper {
      flex: 1;
      display: flex;
      align-items: flex-start;
      justify-content: center;

      .level-icon {
        width: 2rem;
        flex-shrink: 0;
        position: relative;
        top: -0.1rem;
      }
    }

    .account-box {
      flex: 1;
      width: 100%;
      background: url('/static/image/promote/home/img_tg_zhdb.avif') no-repeat center center;
      background-size: cover;
      padding: 0.1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      line-height:0.35rem;

      .account-row {
        display: flex;
        align-items: center;

        &:first-child {
          margin-top: 0.02rem;
        }

        .account-label {
          color: #fbe4c1;
          font-size: 0.28rem;
        }

        .account-value {
          color: #fff;
          font-size: 0.3rem;
          font-weight: 600;
        }

        .help-btn {
          width: 0.36rem;
          height: 0.36rem;
          background: #fff;
          color: #dfb372;
          border-radius: 50%;
          font-size: 0.16rem;
          font-weight: bold;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-left: 0.05rem;
          cursor: pointer;
        }
      }
    }
  }

  .card-right {
    width: 62%;
    padding-left: 0.3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .info-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.04rem;
      line-height:0.45rem;

      &:last-child {
        margin-bottom: 0;
      }

      .row-label-title {
        color: #fde7c6;
        font-size: 0.28rem;
        display: flex;
        align-items: center;
        flex: 1;
        .row-label-content{
            color:#fff1dd;
            font-size: 0.3rem;
            font-weight:600;
            margin-right: 0.1rem;
        }
      }

      .copy-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        cursor: pointer;
        margin-left: 0.1rem;
      }

      .invite-wrap {
        display: flex;
        align-items: center;
        .row-value {
          margin-right: 0.05rem;
        }
      }
    }
  }
}

.qr-section {
  background: #333436;
  border-radius: 0.16rem;
  padding: 0.2rem;
  box-sizing: border-box;
  display: flex;
  margin-bottom: 0.24rem;

  .qr-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(90deg, #f3ca8e 0%, #dfb372 100%);
    border-radius: 0.2rem;
    padding: 0.15rem;
    margin:0.2rem 0.2rem;

    .qr-placeholder {
      width: 1.5rem;
      height: 1.5rem;
      background: #fff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.1rem;
      padding:0.1rem;

      .qr-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .qr-tip {
      color: #333;
      font-size: 0.22rem;
      font-weight: bold;
    }
  }

  .qr-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .share-link {
      display: flex;
      align-items: center;
      background: #292A2C;
      border-radius: 0.08rem;
      padding: 0.1rem;
      margin-bottom: 0.15rem;

      .link-select {
        width: 90%;
        min-width: 0;
        background: transparent;
        border: none;
        outline: none;
        color: #999;
        font-size: 0.3rem;
        padding: 0;
        box-sizing: border-box;
        appearance: none;
        -webkit-appearance: none;

        option {
          background: #292A2C;
          color: #999;
        }
      }

      .link-copy {
        color: #DFB372;
        margin-left: 0.1rem;
        cursor: pointer;
        flex-shrink: 0;
      }
    }

    .share-buttons {
          display: flex;
          overflow-x: auto;
          white-space: nowrap;
          gap: 0.3rem;
          padding-right: 0.1rem;

          &::-webkit-scrollbar {
            display: none;
          }

          .share-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            flex-shrink: 0;

            .share-icon-share {
              width: 1.1rem;
              height: 1.1rem;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 0.08rem;
            }

            .share-icon-img {
              width: 1.1rem;
              height: 1.1rem;
              object-fit: contain;
              margin-bottom: 0.08rem;
            }

            .share-text {
              color: #898989;
              font-size: 0.3rem;
              text-align: center;
              margin-top: 0.1rem;
            }
          }
        }
  }
}

.stats-row {
  background: #333436;
  border-radius: 0.16rem;
  padding: 0.2rem 0.3rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.35rem;

  .stat-left, .stat-right {
    display: flex;
    align-items: baseline;

    .stat-label {
      color: #888;
      font-size: 0.3rem;
      margin-right: 0.1rem;
    }

    .stat-num {
      font-size: 0.35rem;
      font-weight: 600;

      &.gold {
        color: #DFB372;
      }
    }
  }
}

.data-card {
  background: #333436;
  border-radius: 0.16rem;
  padding: 0.2rem;
  box-sizing: border-box;
  margin-bottom: 0.24rem;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.2rem;

    .card-title-row {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding-right: 0.2rem;

        &.inline {
          flex-direction: row;
          align-items: center;
          flex-wrap: wrap;

          .activity-tag {
            margin-bottom: 0;
            margin-right: 0.08rem;
          }
        }

        .title {
          color: #fff;
          font-size: 0.35rem;
          font-weight: 500;
          margin-bottom: 0.04rem;
        }

        .subtitle {
          color: #888;
          font-size: 0.3rem;
        }

        .activity-tag {
          display: inline-block;
          width: fit-content;
          color: #fff;
          font-size: 0.35rem;
          padding: 0.02rem 0.08rem;
          border-radius: 0.04rem;
          margin-bottom: 0.04rem;
        }

        .activity-desc {
          color: #fff;
          font-size: 0.3rem;
        }
      }

    .card-action {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      margin-top: 0.04rem;

      .receive-btn {
        width: 1.26rem;
        height: 0.5rem;
        line-height: 0.5rem;
        background: #999;
        color: #1e1f24;
        font-size: 0.3rem;
        padding: 0.1rem 0.15rem;
        border-radius: 0.65rem;
        margin-right: 0.1rem;
        cursor: pointer;
        text-align: center;
      }

      .receive-btn.gray {
        background: #666;
        color: #fff;
      }

      svg {
        flex-shrink: 0;
      }
    }
  }

  .card-body {
    .data-row {
      display: flex;
      justify-content: space-between;
      padding: 0.08rem 0;

      &:not(:last-child) {
        border-bottom: 1px dashed #444;
      }

      .data-item {
        flex: 1;
        display: flex;
        align-items: center;

        &:first-child {
          margin-right: 0.3rem;
        }

        .data-label {
          color: #888;
          font-size: 0.3rem;
          margin-right: 0.08rem;
        }

        .data-value {
          color: #fff;
          font-size: 0.35rem;
          font-weight: 600;

          &.gold {
            color: #DFB372;
            font-weight: bold;
          }
        }
      }
    }
  }
}

.bottom-space {
  height: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/component/promote/Home.vue